import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/layout/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import WebsiteList from './pages/WebsiteList';
import WebsiteNew from './pages/WebsiteNew';
import WebsiteEdit from './pages/WebsiteEdit';
import WebsiteDetail from './pages/WebsiteDetail';
import MainWPReportPage from './pages/MainWPReport';
import MinioBucketReportPage from './pages/MinioBucketReport';
import BackupSlotsPage from './pages/BackupSlotsPage';
import BackupManagement from './pages/BackupManagement';
import BillingPage from './pages/BillingPage';
import SystemConfigPage from './pages/SystemConfigPage';

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Routes>
          {/* Route de connexion non protégée */}
          <Route path="/login" element={<Login />} />
          
          {/* Toutes les autres routes sont protégées */}
          <Route path="/*" element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/sites" element={<WebsiteList />} />
                  <Route path="/sites/new" element={<WebsiteNew />} />
                  <Route path="/sites/:id" element={<WebsiteDetail />} />
                  <Route path="/sites/:id/edit" element={<WebsiteEdit />} />
                  <Route path="/reports/mainwp" element={<MainWPReportPage />} />
                  <Route path="/reports/minio" element={<MinioBucketReportPage />} />
                  <Route path="/backups/slots" element={<BackupSlotsPage />} />
                  <Route path="/reports/backup-slots" element={<BackupSlotsPage />} />
                  <Route path="/backups/management" element={<BackupManagement />} />
                  <Route path="/billing" element={<BillingPage />} />
                  <Route path="/admin/system" element={
                    <AdminRoute>
                      <SystemConfigPage />
                    </AdminRoute>
                  } />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Layout>
            </ProtectedRoute>
          } />
        </Routes>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App; 